/** Broadcast community credit balance changes to header and other listeners. */
export function notifyCommunityCreditsChanged(remainingCredits) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('communityCreditsChanged', {
    detail: {
      remainingCredits: typeof remainingCredits === 'number' ? remainingCredits : null,
    },
  }));
}

/** Apply remainingCredits from the consume/refund API, or decrement/increment locally. */
export function applyCreditDelta(currentCredits, remainingCredits, delta = 0) {
  if (typeof remainingCredits === 'number') return remainingCredits;
  if (typeof currentCredits === 'number') return Math.max(0, currentCredits + delta);
  return null;
}
